class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;  
        this.predictiveSearchResults.querySelectorAll("ul li").forEach(ele => {
          ele.classList.add("visually-hidden");
        })
        
        
        var imageSources = [];
        
        new DOMParser().parseFromString(resultsMarkup, 'text/html').querySelectorAll('ul li img').forEach(el => {
          imageSources.push(el.src);
        })
        
        console.log(imageSources, new DOMParser().parseFromString(resultsMarkup, 'text/html').querySelectorAll('ul li img'));


        var _this = this;
        _this.open();

        
        function loadImage(src) {
          return new Promise(function(resolve, reject) {
            var image = new Image();
            image.src = src;
            image.onload = function() {
              resolve(image);
              if(document.querySelector("[src='" + image.src.replace("https:","") + "']") != null){
                document.querySelector("[src='" + image.src.replace("https:","") + "']").closest("li").classList.remove("visually-hidden")
              }
            };
            image.onerror = function() {
              reject(new Error('Failed to load image: ' + src));
            };
          });
        }

        imageSources.forEach(loadImage);

      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);